import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MangoCoreModule } from '@mango/core';
import { mangoStandalone } from './mango-standalone';
import { MaterialModule } from '../modules/material.module';
import { ItemTileComponent } from './components/item-tile/itemtile.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { AuthorizationModule } from '@mango/authorization';
import { UserCollectionComponent } from '../user/user-collection.component';
import { UserFilterComponent } from '../user/user-filter.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { AlertsPopupComponent } from './components/alert-popup/alert-popup.component';
import { componentsExtra } from '../components-extra';
import { components } from '../components';
import { AuthenticationModule } from '@mango/authentication';


const sharedCollections = [
    
]

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MangoCoreModule,
        MaterialModule,
        ItemTileComponent,
        RouterModule,
        FlexLayoutModule,
        AuthenticationModule,
        AuthorizationModule,
        AlertsPopupComponent,
        componentsExtra,
        sharedCollections,
        mangoStandalone,
        //*********************************************************/
        components //TODO: Move all from this into separate modules!
        //*********************************************************/
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MangoCoreModule.forRoot(),
        MaterialModule,
        FlexLayoutModule,
        AuthenticationModule,
        RouterModule,
        AuthorizationModule.forRoot({ UserCollectionComponent: UserCollectionComponent, UserFilterComponent: UserFilterComponent, userDetailRouterLink: '/users/detail' }),
        mangoStandalone, ItemTileComponent,
        BaseLayoutComponent,
        AlertsPopupComponent,
        componentsExtra,
        sharedCollections,
        components], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class SharedModule { }
